import querystring from 'querystring';
import io from 'socket.io-client';
import { v4 } from 'uuid';

let socket;
export const initiateSocket = room => {
  const defaultKey = 'smartbotsWebChatUserId';
  const currentUrl = window.location.href;
  let uId = localStorage.getItem(defaultKey);
  const accessToken = localStorage.getItem('accessToken');
  const botID = JSON.parse(
    Object.values(querystring.parse(currentUrl))[0] || null
  )?.config?.botId;
  if (!uId) {
    uId = v4();
    localStorage.setItem(defaultKey, uId);
  }

  socket = io({
    auth: {
      accessToken
    },
    query: {
      botID
    },
    forceNew: true,
    reconnection: true,
    reconnectionAttempts: 300,
    reconnectionDelay: 1200
  });

  socket.on('disconnect', () => {
    console.log('Websocket - Disconnected');
    localStorage.setItem('disconnected', 'true');
  });

  socket.on('connect', () => {
    if (localStorage.getItem('disconnected') === 'true') {
      console.log('Websocket - Connected');
      localStorage.setItem('disconnected', 'false');
      //window.location.reload();
    }
  });

  if (socket && room) socket.emit('join', room);
  return socket;
};
export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};

export const subscribeToChat = cb => {
  if (!socket) return true;
  socket.on('realtime', msg => {
    return cb(null, msg);
  });
};
export const onDisconnect = cb => {
  if (!socket) return true;
  socket.on('disconnect', msg => {
    return cb(null, msg);
  });
};
export const onConnect = cb => {
  if (!socket) return true;
  socket.on('connect', msg => {
    return cb(null, msg);
  });
};
export const sendMessage = (room, message) => {
  if (socket) socket.emit('chat', { message, room });
};
